import { HttpErrorResponse, HttpHandlerFn, HttpRequest, HttpEvent } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { RuntimeConfigService } from "@app/runtime-config.service";
import { AuthService } from "./auth.service";
import { environment } from "environments/environment";
import { catchError, throwError, switchMap, Observable } from "rxjs";

// @Injectable({ providedIn: "root" })
// export class AuthInterceptor implements HttpInterceptor {
//   private runtimeEnvironment = inject(RuntimeConfigService);
//   private router = inject(Router);

//   /** Inserted by Angular inject() migration for backwards compatibility */
//   constructor(...args: unknown[]);

//   // expiryTime: Timer;

//   constructor() {}

//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     let headers = request.headers.set("Accept-Language", "ca");
//     if (localStorage.getItem("accessToken")) {
//       headers = headers.set("Authorization", "Bearer " + localStorage.getItem("accessToken"));
//     }

//     // If "internal" header 'X-Skip-AuthInterceptor' is present, don't add 'x-ibm-client-id' (used to prevent
//     // cyclic dependency when loading the JSON with th client-id)
//     if (!request.headers.has("X-Skip-AuthInterceptor")) {
//       headers = headers.set("x-ibm-client-id", this.runtimeEnvironment?.config["x-ibm-client-id"]);
//     }

//     // Delete "internal" header 'X-Skip-AuthInterceptor'
//     headers = headers.delete("X-Skip-AuthInterceptor");

//     if (request.url.includes("token")) {
//       headers = headers.delete("x-ibm-client-id");
//     }

//     // Clone the request to add the new headers
//     request = request.clone({ headers });
//     console.log("interceptor", request);
//     console.log("interceptor", next);
//     // Pass the cloned request instead of the original request to the next handle
//     return next.handle(request).pipe(
//       catchError((err) => {
//         console.log("interceptor error", err);
//         if (err instanceof HttpErrorResponse) {
//           if (err.status === 401 || err.statusText === "Unauthorized") {
//             localStorage.removeItem("codeVerifier");
//             localStorage.removeItem("accessToken");
//             localStorage.removeItem("refreshToken");
//             localStorage.removeItem("idToken");
//             window.location.reload();
//           } else if (err.status === 403) {
//             this.router.navigate(["/403"]);
//           } else if (err.status === 404) {
//             // NO OP (?)
//           } else if (err.status === 0) {
//             // This is a failed OPTIONS error (CORS?)
//             // NO OP (?)
//           } else if (err.url === null || err.statusText === "Unknown Error" || err.statusText === "Unauthorized") {
//             window.location.reload();
//           }
//         }
//         return throwError(() => err);
//       })
//     );
//   }
// }

export function authInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const runtimeEnvironment = inject(RuntimeConfigService);
  const authService = inject(AuthService);

  // Función auxiliar para añadir headers a la petición
  const addHeaders = (req: HttpRequest<unknown>): HttpRequest<unknown> => {
    let headers = req.headers.set("Accept-Language", "ca");

    if (localStorage.getItem("accessToken")) {
      headers = headers.set("Authorization", "Bearer " + localStorage.getItem("accessToken"));
    }

    if (environment) {
      if (!req.headers.has("X-Skip-AuthInterceptor") ||
          (!req.url.includes("icons/font-awesome") && !req.url.includes("icons/heroicons-outline"))) {
        headers = headers.set("x-ibm-client-id", environment.xIbmClientId);
      }
    }

    headers = headers.delete("X-Skip-AuthInterceptor");

    if (req.url.includes("token")) {
      headers = headers.delete("x-ibm-client-id");
      headers = headers.delete("Authorization");
    }

    return req.clone({ headers });
  };

  // Añadir headers a la petición original
  request = addHeaders(request);

  // Manejar la petición
  return next(request).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        // Si es un 401 (Unauthorized) y tenemos refreshToken, intentar refrescar
        if ((err.status === 401 || err.statusText === "Unauthorized") && !request.url.includes("token")) {
          const refreshToken = localStorage.getItem("refreshToken");

          if (refreshToken && refreshToken !== "undefined") {
            // Intentar refrescar el token
            return authService.getRefreshToken().pipe(
              switchMap((result) => {
                if (result) {
                  // Token refrescado con éxito, reintentar la petición original
                  const retryRequest = addHeaders(request);
                  return next(retryRequest);
                } else {
                  // No se pudo refrescar, limpiar y redirigir
                  localStorage.removeItem("accessToken");
                  localStorage.removeItem("refreshToken");
                  localStorage.removeItem("idToken");
                  router.navigate(["/"]);
                  return throwError(() => err);
                }
              }),
              catchError((refreshError) => {
                // Error al refrescar, limpiar y redirigir
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");
                localStorage.removeItem("idToken");
                router.navigate(["/"]);
                return throwError(() => err);
              })
            );
          } else {
            // No hay refreshToken, limpiar y redirigir
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            router.navigate(["/"]);
          }
        } else if (err.status === 403) {
          router.navigate(["/403"]);
        } else if (err.status === 404) {
          router.navigate(["/404"]);
        } else if (err.status === 0) {
          // This is a failed OPTIONS error (CORS?)
          // NO OP (?)
        }
      }
      return throwError(() => err);
    })
  );
}
